import logger from '@/utils/logger'
import { API_NONCE_MAX_AGE_MS, API_NONCE_CHECK_INTERVAL_MS } from '@/constants'

// Keeps the single-use API nonce fresh while a page that needs it is on screen.
// The nonce dies server side after API_NONCE_TTL_MS, so a user who lingers on
// the login form or the 2FA code screen would otherwise submit with a dead one.
//
// Age is derived from the store timestamp rather than trusted to the interval
// itself: a hidden tab gets its timers throttled onto a one-minute grid, so a
// blind 4-minute interval could fire late enough for the nonce to expire. Here
// a late tick simply sees the real age and refetches at once.
export default {
  data () {
    return {
      nonceRefreshId: null
    }
  },
  methods: {
    startNonceRefresh () {
      if (this.nonceRefreshId) return
      this.refreshNonceIfStale()
      this.nonceRefreshId = setInterval(this.refreshNonceIfStale, API_NONCE_CHECK_INTERVAL_MS)
      document.addEventListener('visibilitychange', this.onNonceVisibilityChange)
    },
    stopNonceRefresh () {
      clearInterval(this.nonceRefreshId)
      this.nonceRefreshId = null
      document.removeEventListener('visibilitychange', this.onNonceVisibilityChange)
    },
    onNonceVisibilityChange () {
      // a hidden tab has its timers throttled, so catch up the moment the user
      // comes back rather than waiting for a tick that may fire a minute late
      if (!document.hidden) this.refreshNonceIfStale()
    },
    refreshNonceIfStale () {
      const fetchedAt = this.$store.state.apiNonceFetchedAt
      const age = fetchedAt ? Date.now() - fetchedAt : Infinity
      if (age < API_NONCE_MAX_AGE_MS) return
      // Swallow failures: the nonce in hand may still be good, the next tick
      // retries anyway, and a background refresh must never raise an error
      // banner on a form the user is still filling in.
      return this.$store.dispatch('fetchApiNonce')
        .catch(err => logger.log(`[NONCE] refresh failed: ${err.message}`))
    }
  },
  mounted () {
    this.startNonceRefresh()
  },
  beforeDestroy () {
    this.stopNonceRefresh()
  }
}
